/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { Link, graphql } from "gatsby"

// Components
import Layout from "../components/Layout"
import CategoryContainer from "../components/CategoriesContainer"
import CategoryBlob from "../components/CategoryBlob"

const Blog = ({ data, pageContext: { category } }) => {
  const { edges: posts } = data.allMdx
  const categories = posts.reduce((categoriesArray, { node: post }) => {
    if (!categoriesArray.includes(post.frontmatter.category)) {
      return [...categoriesArray, post.frontmatter.category]
    }

    return categoriesArray
  }, [])

  return (
    <Layout showHeading>
      <section
        className="container"
        css={css`
          padding-top: 125px;

          a {
            color: rgb(233, 33, 33);
          }
        `}
      >
        {category && (
          <header>
            <h1>Categoría: {category}</h1>
          </header>
        )}

        {categories.length && !category && (
          <CategoryContainer categories={categories} />
        )}

        {category && (
          <Link
            to="/blog"
            css={css`
              margin-top: 15px;
              padding: 5px;
              display: inline-block;
            `}
          >
            Ir atrás
          </Link>
        )}

        {posts.length ? (
          <ul
            css={css`
              margin: 50px 0;
              width: 100%;
            `}
          >
            {posts.map(({ node: post }) => (
              <article
                key={post.id}
                css={css`
                  margin: 25px 0;
                  padding: 25px;
                  background-color: #f9f9f9;
                `}
              >
                <header>
                  <Link to={post.fields.slug}>
                    <h2>{post.frontmatter.title}</h2>
                  </Link>
                </header>

                <section
                  css={css`
                    font-size: 14px;
                  `}
                >
                  Categoría:{" "}
                  <CategoryBlob category={post.frontmatter.category} />
                </section>

                <time
                  css={css`
                    font-size: 12px;
                  `}
                >
                  <span>Fecha de publicación: {post.frontmatter.date}</span>
                </time>

                <section
                  css={css`
                    font-size: 12px;
                  `}
                >
                  <span>
                    Tiempo de lectura:{" "}
                    {post.timeToRead === 1
                      ? `${post.timeToRead} minuto`
                      : `${post.timeToRead} minutos`}{" "}
                  </span>
                </section>

                <summary
                  css={css`
                    margin-top: 15px;
                  `}
                >
                  <p>{post.excerpt}</p>
                </summary>
              </article>
            ))}
          </ul>
        ) : (
          <h2>Actualmente no hay ningún post.</h2>
        )}
      </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query blog($category: String) {
    allMdx(
      sort: { fields: frontmatter___date, order: DESC }
      filter: { frontmatter: { category: { eq: $category } } }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 200)
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "DD/MM/YYYY")
            category
            keywords
          }
          timeToRead
        }
      }
    }
  }
`

export default Blog
